import {createAction} from '@reduxjs/toolkit'

const name = 'APP'

export const online = createAction<boolean>(`${name}/online`)
